import React, { useContext } from "react";
import Icon from "../../_default/Icon";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import UserContext from "../../../services/context/userContext";
import FeatherIcon from "feather-icons-react";
import "./FormList.scss";

//  highlight file
export default function FormList({ form, from, onDragEnd, copyItem, removeItem, onClick }) {
  const user = useContext(UserContext);
  const isAdmin = !(from === "aurum" && !user.admin);
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="sets" type="parent">
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {form &&
              form.map((item, idx) => (
                <Draggable key={item.id} index={idx} draggableId={item.id}>
                  {(provided, snapshot) => (
                    <div
                      className={`c-form-item ${snapshot.isDragging ? "--ondrag" : ""}`}
                      isDragging={snapshot.isDragging}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      onClick={(e) => {
                        e.stopPropagation();
                        onClick(item);
                      }}>
                      <div className="c-form-title">
                        <p>{item.question}</p>
                      </div>
                      <div className="c-form-content">
                        <i>{item.question_type}</i>
                        <div className="c-btn-collection">
                          {from === "aurum" ? (
                            <>
                              <div
                                className="c-set-copy-icon"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  copyItem(item);
                                }}
                              >
                                Copy
                                <FeatherIcon icon="copy" size="13" color="#000" />
                              </div>
                              {user.admin && (
                                <>
                                  <div
                                    className="c-set-trash-icon"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      removeItem(item);
                                    }}
                                  >
                                    <Icon icon="trash" size={16} />
                                  </div>
                                  <div className="c-set-move-icon" {...provided.dragHandleProps} onClick={(e) => e.stopPropagation()}>
                                    <Icon icon="move" />
                                  </div>
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <div
                                className="c-set-trash-icon"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  removeItem(item);
                                }}
                              >
                                <Icon icon="trash" size={16} />
                              </div>
                              <div className="c-set-move-icon" {...provided.dragHandleProps} onClick={(e) => e.stopPropagation()}>
                                <Icon icon="move" />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
